module.exports = __webpack_public_path__ + "img/logo.bd734c7f.svg";